import { ConnectedBuyFormatCurrency } from '@buy/connectedComponents'
import { OrderSummaryLine } from '@buy/state/order-summary/order-summary'
import React, { FunctionComponent, useEffect } from 'react'
import { isEmpty, isUndefined } from 'lodash-es'
import { getPrice } from '@buy/utils/volume-components-helpers'
import { BillingPeriod } from '@common/constants'
import styles from '../../connectedComponents/OrderSummary/order-summary.module.css'
import { BillingTenureValue } from '../BillingPeriodSwitch'
import { AdditionalLinesSummary } from '../AdditionalLinesSummary/AdditionalLinesSummary'

interface AddonsSummaryProps {
    lines: Array<OrderSummaryLine>
    baseLine: OrderSummaryLine
    isAnnual: boolean
    mainTitle?: string
    setSubTotal: (value: number) => void
    subTotal: number
    billingTenure: BillingTenureValue
}

export const AddonsSummaryWrapper: FunctionComponent<AddonsSummaryProps> = ({
    lines,
    isAnnual,
    mainTitle = 'Add-Ons',
    setSubTotal,
    subTotal,
    billingTenure,
}) => {
    const calculateSubTotal = () => {
        let total = 0
        lines.forEach((line) => {
            if (isUndefined(line.usagePrice))
                // don't include usage price to the subtotal for this section
                total +=
                    getPrice(
                        line.multiplier,
                        line.allPrices[isAnnual ? BillingPeriod.ANNUAL : billingTenure.leftOption!]
                    ) *
                    (line.quantity || 0) *
                    (isAnnual ? 12 : 1)
            else {
                const price = getPrice(line.multiplier, line.allPrices[BillingPeriod.MONTHLY]) * (line.quantity || 0)
                if (price !== 0) total += price
            }
        })
        setSubTotal(total)
    }

    useEffect(() => {
        calculateSubTotal()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lines, isAnnual])

    return (
        <>
            {!isEmpty(lines) && (
                <div key="extraAddonsSelected" className={styles.section}>
                    <div className={styles.row} data-qat="total-extra-add-ons">
                        <span className={styles['item-title']} data-qat="line-item-name">
                            {mainTitle}
                        </span>
                        {subTotal > 0 && (
                            <span className={`${styles.item}`} data-qat="line-item-subtotal">
                                <ConnectedBuyFormatCurrency value={subTotal} />
                            </span>
                        )}
                    </div>
                    {lines.map((item) => (
                        <AdditionalLinesSummary
                            line={item}
                            isAnnual={isAnnual}
                            showSubTotal={false}
                            isAddon
                            addonText={mainTitle}
                            billingTenure={billingTenure}
                        />
                    ))}
                </div>
            )}
        </>
    )
}
